export const unitListEn = {
  unitList: {
    actions: {
      bulkUpdate: 'Bulk Update',
    },
    banners: {
      zeroRentNotSyndicated: 'Units that have Rent with $0 value might not be syndicated to all Rental Listing Sites.',
    },
    filters: {
      search: 'Search',
      property: 'Property',
      availability: 'Availability',
      numberOfBeds: '# of Beds',
      numberOfBaths: '# of Baths',
      allFilters: 'All Filters',
      removeFilters: 'Remove ({count}) filter | Remove ({count}) filters',
    },
    cardFormOptions: {
      property: 'Properties',
      available: 'Availability',
      cityId: 'Cities',
      numBedsBaths: '# of Beds/Baths',
      status: 'Status',
      bsLinked: 'Linked to Building Stack',
    },
    columns: {
      property: 'Property',
      name: 'Name',
      unitNumber: 'Unit #',
      bedsBaths: 'Beds/Baths',
      sqFt: 'SqFt.',
      rent: 'Rent',
      media: 'Media',
      availability: 'Availability',
      status: 'Status',
    },
    tooltips: {
      bedIncrement: 'Input should be in increments of 1.',
      bathIncrement: 'Input should be in increments of 0.5.',
      excludeLastPromotedUnit: 'This property has an active promoted listing. Please manage the promoted listing before excluding the last enabled unit from listings.',
      bulkExcludeLastPromotedUnit: 'At least one selected property has an active promoted listing. Please manage the promoted listing before excluding its last enabled unit from listings.',
    },
    colourKey: {
      title: 'Learn More - Colour Key',
      excludedFromSyndication: 'Unit excluded from syndication',
      hiddenOnWebsite: 'Unit hidden on website',
      hiddenAndExcluded: 'Unit hidden on website and excluded from syndication',
    },
    values: {
      available: 'Available',
      availableOnDate: 'Available on Date',
      unavailable: 'Unavailable',
      waitingList: 'Waiting List',
      waitingListOnly: 'Waiting List Only',
      availableOn: '(on {date})',
      bedroom: 'bedroom',
      bedrooms: 'bedrooms',
      bath: 'bath',
      baths: 'baths',
      yes: 'Yes',
      no: 'No',
    },
  },
} as const;

export const unitListFr = {
  unitList: {
    actions: {
      bulkUpdate: 'Mise à jour en lot',
    },
    banners: {
      zeroRentNotSyndicated: 'Les unités dont le loyer est de 0 $ pourraient ne pas être diffusées sur tous les sites d\'annonces locatives.',
    },
    filters: {
      search: 'Rechercher',
      property: 'Propriété',
      availability: 'Disponibilité',
      numberOfBeds: '# de chambres',
      numberOfBaths: '# de salles de bain',
      allFilters: 'Tous les filtres',
      removeFilters: 'Retirer ({count}) filtre | Retirer ({count}) filtres',
    },
    cardFormOptions: {
      property: 'Propriétés',
      available: 'Disponibilité',
      cityId: 'Villes',
      numBedsBaths: '# de chambres/salles de bain',
      status: 'Statut',
      bsLinked: 'Lié à Building Stack',
    },
    columns: {
      property: 'Propriété',
      name: 'Nom',
      unitNumber: 'N° d\'unité',
      bedsBaths: 'Chambres/Salles de bain',
      sqFt: 'Pi. ca.',
      rent: 'Loyer',
      media: 'Médias',
      availability: 'Disponibilité',
      status: 'Statut',
    },
    tooltips: {
      bedIncrement: 'La valeur doit être saisie par incréments de 1.',
      bathIncrement: 'La valeur doit être saisie par incréments de 0,5.',
      excludeLastPromotedUnit: 'Cette propriété a une annonce promue active. Veuillez gérer l\'annonce promue avant d\'exclure de la diffusion la dernière unité activée.',
      bulkExcludeLastPromotedUnit: 'Au moins une propriété sélectionnée a une annonce promue active. Veuillez gérer l\'annonce promue avant d\'exclure de la diffusion sa dernière unité activée.',
    },
    colourKey: {
      title: 'En savoir plus - Code de couleurs',
      excludedFromSyndication: 'Unité exclue de la diffusion',
      hiddenOnWebsite: 'Unité masquée sur le site web',
      hiddenAndExcluded: 'Unité masquée sur le site web et exclue de la diffusion',
    },
    values: {
      available: 'Disponible',
      availableOnDate: 'Disponible à une date',
      unavailable: 'Non disponible',
      waitingList: 'Liste d\'attente',
      waitingListOnly: 'Liste d\'attente seulement',
      availableOn: '(le {date})',
      bedroom: 'chambre',
      bedrooms: 'chambres',
      bath: 'salle de bain',
      baths: 'salles de bain',
      yes: 'Oui',
      no: 'Non',
    },
  },
} as const;
